<!--
 * @Description: 
 * @Date: 2020-09-24 15:37:16
-->
<template>
  <div class="person">
    <div class="person-header" @click="jump({target:'setting'})">
      <div class="person-header-content" v-if="user.phone">
        <img
          :src="user.headPhoto || 'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/defaultPhoto.png'"
          alt
        />
        <div class="person-header-mid">
          <h5 class="person-header-mid-name">{{user.fullName}}</h5>
          <div class="person-header-mid-integral">
            <span>积分：</span>
            <h5>{{user.integral || 0}}分</h5>
          </div>
        </div>
        <van-icon class="person-header-right" name="arrow" />
      </div>
      <h5 v-else class="person-header-login">登录/注册</h5>
    </div>
    <ul>
      <template v-for="(item,index) in list">
        <li :key="index" @click="jump(item)" v-if="controlShow(item)">
          <img :src="item.icon" alt />
          <span>{{item.text}}</span>
          <van-icon name="arrow" />
        </li>
      </template>
    </ul>
    <van-action-sheet
      v-model="showLogout"
      :actions="actions"
      cancel-text="取消"
      description="确认退出登录？"
      close-on-click-action
      @select="select"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { syncUserInfo, storageUserInfo } from '@/utils/storage';
import { hideSomeString } from '@/utils/tools';
import { logout } from '@/api/ajax';
export default {
  data() {
    return {
      showLogout: false,
      actions: [{ name: '确认退出' }],
      user: {},
      list: [
        {
          icon: require('../../assets/我的积分.png'),
          text: '我的积分',
          target: 'integral'
        },
        {
          icon: require('../../assets/我的收藏.png'),
          text: '我的收藏',
          target: 'collection'
        },
        {
          icon: require('../../assets/个人设置.png'),
          text: '个人设置',
          target: 'setting'
        },
        {
          icon: require('../../assets/退出登录.png'),
          text: '退出登录',
          target: 'logout'
        }
      ]
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    ...mapMutations(['SET_USER']),
    jump({ target }) {
      if (!this.user.phone) {
        this.$router.push({ name: 'register' });
        return;
      }
      if (target !== 'logout') {
        this.$router.push({ name: target });
        return;
      }
      this.showLogout = true;
    },
    async select(action) {
      localStorage.clear();
      sessionStorage.clear();
      await logout();
      this.$router.push({ name: 'home' });
    },
    controlShow(item) {
      let white = ['collection', 'setting'];
      if (this.user.phone) {
        return true;
      } else {
        if (white.includes(item.target)) {
          return true;
        }
        return false;
      }
    }
  },
  async created() {
    let { id } = await storageUserInfo();
    if (id) {
      this.user = await syncUserInfo();
      this.user.fullName =
        this.user.fullName || hideSomeString(this.user.phone);
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped lang='less'>
.person {
  &-header {
    background-image: url('http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/personbg.png');
    background-size: 100% 100%;
    height: 4.31rem;
    border-bottom-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
    padding: 0.53rem 0.4rem;
    &-login {
      font-size: 0.64rem;
      color: #ffffff;
      text-align: center;
      margin-top: 0.6rem;
    }
    &-content {
      position: relative;
      display: flex;
      align-items: center;
    }
    img {
      width: 1.97rem;
      height: 1.97rem;
      border-radius: 50%;
      margin-right: 0.4rem;
    }
    &-mid {
      &-name {
        font-size: 0.64rem;
        color: #fff;
        margin-bottom: 0.11rem;
      }
      &-integral {
        line-height: 1;
      }
      div {
        display: flex;
        align-items: flex-end;
        span {
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.32rem;
        }
        h5 {
          color: #ffdb23;
          font-size: 0.43rem;
        }
      }
    }
    &-right {
      position: absolute;
      right: 0.1rem;
      font-size: 0.5rem;
      color: #fff;
    }
  }
  ul {
    padding: 0 0.4rem;
    margin-top: -1rem;
    position: relative;
    li {
      background: #fff;
      height: 1.49rem;
      padding: 0.49rem 0.29rem;
      display: flex;
      align-items: center;
      box-shadow: 4px 4px 8px 0px rgba(106, 114, 206, 0.16);
      border-radius: 12px;
      margin-bottom: 0.32rem;
      position: relative;
      img {
        width: 0.53rem;
        height: 0.53rem;
        margin-right: 0.21rem;
      }
      span {
        font-size: 0.43rem;
      }
      i {
        color: #3667ec;
        font-size: 0.43rem;
        position: absolute;
        right: 0.32rem;
      }
    }
  }
  /deep/ .van-action-sheet {
    background: transparent;
    padding: 0.27rem;

    .van-action-sheet__description {
      background: #fff;
      border-top-right-radius: 0.21rem;
      border-top-left-radius: 0.21rem;
      font-size: 0.37rem;
    }
    .van-action-sheet__item {
      border-bottom-right-radius: 0.21rem;
      border-bottom-left-radius: 0.21rem;
      font-size: 0.48rem;
    }
    .van-action-sheet__gap {
      display: none;
    }
    .van-action-sheet__cancel {
      border-radius: 0.21rem;
      margin-top: 0.21rem;
      color: #3667ec;
      font-size: 0.53rem;
      font-weight: 500;
    }
  }
}
</style>
